import { AppContext } from '@/App';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { createContext, useContext } from 'react';
import * as Tooltip from '@radix-ui/react-tooltip';

interface LayoutProps {
  children: React.ReactNode;
}

const LayoutLevelContext = createContext(0);

export function Layout({ children }: LayoutProps) {
  // const [isCollapsed, setIsCollapsed] = useState(false);
  const { isCollapsed, setIsCollapsed } = useContext(AppContext);
  const level = useContext(LayoutLevelContext);

  const content = level > 0 ? (
    <div className="w-full h-full overflow-auto bg-background transition-all duration-300 scrollbar-custom">
      {children}
    </div>
  ) : (
    <div className="h-screen flex flex-col">
      <Header />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        <main className="flex-1 overflow-auto bg-background transition-all duration-300 scrollbar-custom">
          {children}
        </main>
      </div>
    </div>
  );

  return (
    <LayoutLevelContext.Provider value={level + 1}>
      {content}
    </LayoutLevelContext.Provider>
  );
}
